import React, { useEffect, useState } from "react";
import { Button, Table, message, Modal, Empty } from "antd";
import { ArrowRightOutlined, LoadingOutlined } from "@ant-design/icons";
import { get_language, translate } from "../../locale";
import UserServices from "../../services/UserServices";
import moment from "moment";
import { useParams } from "react-router-dom";

const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 24,
    }}
    spin
  />
);

const ProfessionalNotesTable = ({ reload }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [modalDetails, setModalDetails] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [subscriptions, setSubscriptions] = useState(null);
  const { username } = useParams();

  const columns = [
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <div className="flex space-x-4 justify-center">
          <Button
            type="text"
            icon={<ArrowRightOutlined />}
            size="small"
            className="border-0"
            onClick={() => handleShowDetails(record)}
          />
        </div>
      ),
      width: 100,
    },
    {
      title: translate("Fecha"),
      dataIndex: "date",
      key: "date",
      render: (_, record) =>
        moment(record.date).format(
          get_language === "en" ? "MM/DD/YYYY" : "DD/MM/YYYY"
        ),
      sorter: (a, b) => {
        if (a.date < b.date) return -1;
        if (a.date > b.date) return 1;
        return 0;
      },
    },
    {
      title: translate("Autor"),
      dataIndex: "author",
      key: "author",
      render: (_, record) => record.author.username,
      sorter: (a, b) => {
        if (a.author.username < b.author.username) return -1;
        if (a.author.username > b.author.username) return 1;
        return 0;
      },
    },
    {
      title: translate("Nota"),
      dataIndex: "title",
      key: "title",
      sorter: (a, b) => {
        if (a.title < b.title) return -1;
        if (a.title > b.title) return 1;
        return 0;
      },
    },
    {
      title: translate("Descripción"),
      dataIndex: "body",
      key: "body",
      render: (_, record) => (
        <div className="flex flex-row items-center inner-p">
          {record.bodyText.length > 200
            ? record.bodyText.slice(0, 200) + "..."
            : record.bodyText}
        </div>
      ),
    },
  ];

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    if (reload !== null) {
      loadData();
    }
  }, [reload]);

  const loadData = async (subscription_id) => {
    setLoading(true);
    try {
      const res = await UserServices.getNotes(null, username);
      if (res.status >= 200 && res.status < 300 && res.data.notes.length > 0) {
        setData(
          res.data.notes.map((i) => ({
            ...i,
            bodyText: i.body.replace(/(<[^>]+>)/g, "").replace(/&nbsp;/g, " "),
          }))
        );
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleShowDetails = (data) => {
    setModalDetails(true);
    setSelectedData(data);
  };

  const handleHideDetails = () => {
    setModalDetails(false);
  };

  return (
    <>
      <Table
        rowKey={(i) => i.register_date}
        dataSource={data}
        columns={columns}
        loading={
          loading
            ? { indicator: antIcon, className: "text-custom_blue" }
            : false
        }
        locale={{
          emptyText: <Empty description={translate("No hay datos")} />,
          sortTitle: translate("Ordenar"),
          triggerDesc: translate("Ordenar (descendente)"),
          triggerAsc: translate("Ordenar (ascendente)"),
          cancelSort: translate("Cancelar orden"),
        }}
      />
      <Modal
        open={modalDetails}
        title={translate("Nota")}
        onCancel={handleHideDetails}
        footer={[
          <Button key="ok" type="primary" onClick={handleHideDetails}>
            {translate("Aceptar")}
          </Button>,
        ]}
      >
        {selectedData !== null && (
          <>
            <p>
              <strong>{translate("Fecha")}: </strong>{" "}
              {moment(selectedData.date).format(
                get_language === "en" ? "MM/DD/YYYY" : "DD/MM/YYYY"
              )}
              <br />
              <strong>{translate("Autor")}: </strong>{" "}
              {selectedData.author.username}
              <br />
              <strong>{translate("Nota")}: </strong> {selectedData.title}
              <br />
              <br />
              <strong>{translate("Descripción")}: </strong>
            </p>
            <div dangerouslySetInnerHTML={{ __html: selectedData.body }}></div>
          </>
        )}
      </Modal>
    </>
  );
};

export default ProfessionalNotesTable;
